module.exports = __webpack_public_path__ + "static/metrics-a61b3bac93db671d8d293a991f1e89d8.png";